import { Injectable } from '@angular/core';
import { DeviceFormatterService, IDeviceContract } from '@nx-fe/services';

import { IDeviceModel } from 'sspapp/modules/ticket/ticket.model';
import { SspRestApiService } from './sspRestApiService';

export interface IDeviceIdToDeviceMap {
  [deviceId: string]: IDeviceModel;
}

@Injectable()
export class DeviceContextService {
  constructor(private sspRestApiService: SspRestApiService, private deviceFormatterService: DeviceFormatterService) {}

  private _devices: IDeviceIdToDeviceMap = {};
  private _deviceContracts: IDeviceContract[];
  private _selectedDevice: string = null;
  private loadingSSPDevicePromise: Promise<IDeviceContract[]>;

  public get devices(): IDeviceIdToDeviceMap {
    return this._devices;
  }

  public get devicesSsp(): IDeviceContract[] {
    return this._deviceContracts;
  }

  public set devicesSsp(devices: IDeviceContract[]) {
    this._deviceContracts = devices;
  }

  public get selectedDevice(): string {
    return this._selectedDevice;
  }

  public set selectedDevice(deviceId: string) {
    this._selectedDevice = deviceId;
  }

  public getDeviceSsp(deviceId: string): Promise<IDeviceContract> {
    this.reloadDevicesSsp();
    return this.loadingSSPDevicePromise.then((devices: IDeviceContract[]) => {
      return devices.find(device => device.deviceId === deviceId);
    });
  }

  public reloadDevicesSsp = (): Promise<any> => {
    this.loadingSSPDevicePromise = this.sspRestApiService
      .getDeviceList()
      .toPromise()
      .then((devices: any) => {
        return (this.devicesSsp = this.deviceFormatterService.contractsToUI(devices));
      });
    return this.loadingSSPDevicePromise;
  };
}
